function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.739 32.217A9.783 9.783 0 0113.956 42a9.783 9.783 0 01-9.782-9.783 9.783 9.783 0 019.782-9.783 9.783 9.783 0 019.783 9.783zM52 32.217A9.783 9.783 0 0142.217 42a9.783 9.783 0 01-9.782-9.783 9.783 9.783 0 019.782-9.783A9.783 9.783 0 0152 32.217z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.739 30.043s2.174-1.643 4.348-1.63c2.174.012 4.348 1.63 4.348 1.63M4.174 31.13H2s2.35-11.382 7.609-15.635c1.836-1.485 7.608-2.843 7.608-2.843M51.562 31.13h2.174s-2.35-11.382-7.609-15.635c-1.836-1.485-7.609-2.843-7.609-2.843"
}));

var SvgEyeglasses = function SvgEyeglasses(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeglasses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Eyeglasses.9a581bbb.svg";
export { ForwardRef as ReactComponent };